import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { useCopy } from '../contexts/LanguageContext';
const SPARKLES = [{
  x: -68,
  y: -34,
  delay: 0
}, {
  x: 62,
  y: -52,
  delay: 0.15
}, {
  x: -46,
  y: 48,
  delay: 0.3
}, {
  x: 74,
  y: 34,
  delay: 0.45
}, {
  x: 10,
  y: -76,
  delay: 0.6
}];
interface PreparingOverlayProps {
  onDone: () => void;
}
export function PreparingOverlay({
  onDone
}: PreparingOverlayProps) {
  const copy = useCopy();
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const toReady = setTimeout(() => setReady(true), 1500);
    const toDone = setTimeout(onDone, 2900);
    return () => {
      clearTimeout(toReady);
      clearTimeout(toDone);
    };
  }, [onDone]);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.4
  }} className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-cream px-8 text-center" role="status" aria-live="polite" data-id="element-8" data-mp="1a8shsbcd6lzm">
      <div className="relative grid h-32 w-32 place-items-center" data-id="element-9" data-mp="1eyb6dcm30cp7">
        {SPARKLES.map(sparkle => <motion.span key={`${sparkle.x}-${sparkle.y}`} aria-hidden="true" className="absolute text-lg" initial={{
        opacity: 0,
        scale: 0.4
      }} animate={{
        opacity: [0, 1, 0],
        scale: [0.4, 1, 0.5],
        x: sparkle.x,
        y: sparkle.y
      }} transition={{
        duration: 1.8,
        delay: sparkle.delay,
        repeat: Infinity
      }} data-id="element-10" data-mp="11762tzflf09l">
            ✨
          </motion.span>)}

        {!ready ? <motion.div className="h-16 w-16 rounded-full border-[3px] border-lavender-200 border-t-violet-500" animate={{
        rotate: 360
      }} transition={{
        duration: 1.1,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-11" data-mp="i9mt0tlb9dm4" /> : <motion.div initial={{
        scale: 0.5,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        type: 'spring',
        stiffness: 220,
        damping: 16
      }} className="grid h-16 w-16 place-items-center rounded-full bg-violet-600 text-white shadow-lift" data-id="element-12" data-mp="2hlft4z3eaz32">
            <CheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-13" data-mp="266vzlq1a2nuq" />
          </motion.div>}
      </div>

      <motion.p key={ready ? 'ready' : 'loading'} initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.4
    }} className="mt-6 font-display text-xl text-ink" data-id="element-14" data-mp="2181icsiyl7cq">
        {ready ? copy.preparing.ready : copy.preparing.loading}
      </motion.p>
    </motion.div>;
}